import OrderableModel from '@/models/OrderableModel';

export default class Activity extends OrderableModel {
    get route () {
        return 'activities';
    }

    static get className () {
        return 'Activity';
    }

    static get isInStore () {
        return true;
    }
}
